export default "__VITE_ASSET__CbRGHmKh__"